import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[accesskey-func]'
})
export class AccessKeyFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}